const SUBSCRIPTION_FIELDS = [
  'emsCriteria',
  'psPlusSubscription',
  'loyaltySubscription',
  'ubisoftPlusSubscription',
  'gtaPlusSubscription',
  'hashedAccountId',
];

const ACCOUNT_FIELD_KEYS = {
  accountId: ['accountId', 'psnAccountId', 'accountID'],
  accountLanguage: ['accountLanguage', 'psnAccountLanguage', 'language', 'locale'],
  accountRegion: ['accountRegion', 'psnAccountRegion', 'country', 'legalCountry', 'region'],
};

const pickFirstDefined = (...values) => values.find(value => value !== undefined && value !== null);

const isValidAccountValue = (value) => {
  if (value === undefined || value === null) return false;
  if (typeof value === 'string' && value.length === 0) return false;
  return true;
};

const resolveAccountField = (sources, keys) => {
  for (let i = 0; i < sources.length; i += 1) {
    const source = sources[i];

    if (source) {
      for (let j = 0; j < keys.length; j += 1) {
        const value = source[keys[j]];

        if (isValidAccountValue(value)) {
          return value;
        }
      }
    }
  }

  return undefined;
};

const getToolbarSource = () => {
  const { psnWebToolbar, sbWeb } = window;

  return Object.fromEntries(
    Object.entries(ACCOUNT_FIELD_KEYS).map(([field, keys]) => ([
      field,
      resolveAccountField([psnWebToolbar, sbWeb], keys),
    ])),
  );
};

/**
 * Resolves telemetry user data for jetstream telemetry.
 * Priority: opts getter -> opts.userData -> opts fields -> toolbar.
 */
export default function getTelemetryUserData() {
  const opts = window.sharedNav?.opts || {};
  const hostUserData = typeof opts.getTelemetryUserData === 'function'
    ? opts.getTelemetryUserData()
    : {};
  const optsUserData = {
    ...(opts.userData || {}),
    ...hostUserData,
  };
  const sources = [optsUserData, opts, getToolbarSource()];

  const userData = {
    isLoggedIn: pickFirstDefined(optsUserData.isLoggedIn, opts.isLoggedIn),
  };

  Object.entries(ACCOUNT_FIELD_KEYS).forEach(([field, keys]) => {
    userData[field] = resolveAccountField(sources, keys);
  });

  SUBSCRIPTION_FIELDS.forEach((field) => {
    userData[field] = pickFirstDefined(optsUserData[field], opts[field]);
  });

  return userData;
}
